import React, { Component } from "react";
import { withApollo } from "@apollo/react-hoc";
import { Container, Row, Col, Card, Button, CardBody } from "reactstrap";
import Header from "../../organisms/guest-header";
import T from "../../atoms/translate";
import Loading from "../../atoms/loading";
import {
  AppContext,
  buildUserInfo,
  GAevent,
  GAset,
  showToast,
  t,
} from "../../../utils/utils";
import {
  REMOVE_JWT,
  REMOVE_REFRESH_JWT,
  SET_JWT,
  SET_REFRESH_JWT,
  SET_USER_EMAIL,
} from "../../../constants";
import { Link, Redirect } from "react-router-dom";
import { RESEND_VERIFICATION, VERIFY_ACCOUNT } from "../../../api/user";
import validator from "validator";

class VerifyAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        email: props.match.params.email || "",
        token: props.match.params.token || "",
      },
      loading: true,
      verifying: false,
      saving: false,
      isLogged: false,
      messageSended: false,
      isValid: validator.isEmail(props.match.params.email || ""),
    };
  }

  componentDidMount() {
    REMOVE_JWT();
    REMOVE_REFRESH_JWT();
    const { data } = this.state;
    if (data.token !== "" && data.token !== null) {
      this.verifyAccount();
    } else {
      this.setState({ loading: false });
    }
  }

  verifyAccount = async (e) => {
    await this.setState({ loading: false, verifying: true });

    const { mutate } = this.props.client;
    const { data } = this.state;
    //mutacion reenviar verificacion
    try {
      const res = await mutate({
        mutation: VERIFY_ACCOUNT,
        variables: {
          email: data.email,
          verificationToken: data.token,
        },
      });
      if (res && res.data && res.data.verifyAccount) {
        showToast(t("exitoAlVerificar"));
        const {
          id,
          jwt,
          refresh_jwt,
          email,
          firstTime,
        } = res.data.verifyAccount;
        buildUserInfo(this.context, { id, firstTime, email });
        SET_JWT(jwt);
        SET_REFRESH_JWT(refresh_jwt);
        SET_USER_EMAIL(email);
        //se registra el evento de cuenta verificada en google-analytics
        GAevent("User", "VERIFY", { labelName: email });
        //se asocia esta sesión al usuario conectado
        GAset({ userId: id });
        this.setState({ isLogged: true });
      } else {
        showToast(t("errorAlVerificar"), "error");
      }
    } catch ({ graphQLErrors, networkError }) {
      if (graphQLErrors && graphQLErrors.length > 0) {
        showToast(graphQLErrors[0].message, "error");
      } else if (networkError) {
        showToast(t("errorAlVerificar"), "error");
      } else {
        showToast(t("errorAlVerificar"), "error");
      }
    }
    this.setState({ verifying: false });
  };

  onSubmit = async (e) => {
    await this.setState({ saving: true });

    const { mutate } = this.props.client;
    const { data } = this.state;
    //mutacion reenviar verificacion
    try {
      const res = await mutate({
        mutation: RESEND_VERIFICATION,
        variables: {
          email: data.email,
        },
      });
      if (res && res.data && res.data.resendVerificationToken) {
        showToast(t("exitoAlReenviarVerificacion"));
        this.setState({ isLogged: true });
      } else {
        showToast(t("errorAlReenviarVerificacion"), "error");
      }
    } catch ({ graphQLErrors, networkError }) {
      if (graphQLErrors && graphQLErrors.length > 0) {
        showToast(graphQLErrors[0].message, "error");
      } else if (networkError) {
        showToast(t("errorAlReenviarVerificacion"), "error");
      } else {
        showToast(t("errorAlReenviarVerificacion"), "error");
      }
    }
    this.setState({ saving: false });
  };

  render() {
    const {
      isLogged,
      data,
      saving,
      isValid,
      messageSended,
      loading,
      verifying,
    } = this.state;
    if (isLogged) return <Redirect to="/projects" />;
    return (
      <>
        <Header />
        <Container style={{ minHeight: "80vh" }}>
          <Row>
            <Col xs="11" md="6" lg="5" className="mx-auto">
              <Card className="mt-5 box-shadow rounded-xg border-gris-100 generic-card">
                <CardBody>
                  {loading ? (
                    <div>...</div>
                  ) : verifying ? (
                    <Row>
                      <Col xs="12">
                        <Loading width={300} height={300} animation={6} />
                      </Col>
                    </Row>
                  ) : (
                    <>
                      <Row>
                        <Col xs="12">
                          <h3 className="text-center text-primary">
                            <T i18nKey="verificaTuCuenta" />
                          </h3>
                        </Col>
                        <Col xs="12">
                          <p className="my-2">
                            <T
                              i18nKey="mensajeVerificacionCuenta"
                              values={{ email: data.email }}
                            />
                          </p>
                        </Col>
                      </Row>
                      {!messageSended && isValid && (
                        <Row>
                          <Col xs="12">
                            <hr />
                          </Col>
                          <Col xs="12">
                            <p className="my-2 mb-3 text-center">
                              <T i18nKey="opcionReenviarEmailVerificacion" />
                            </p>
                          </Col>
                          <Col
                            xs="9"
                            md="6"
                            lg="5"
                            className="text-center mx-auto"
                          >
                            <Button
                              block
                              className="fw-500"
                              color="primary"
                              onClick={this.onSubmit}
                              disabled={saving || !isValid}
                            >
                              {saving
                                ? t("espere...")
                                : t("enviarCorreoVerificacion")}
                            </Button>
                          </Col>
                        </Row>
                      )}
                      <Row>
                        <Col xs="12" className="mt-4">
                          <hr />
                        </Col>
                        <Col xs="12" className="text-center">
                          <Link to="/">
                            <T i18nKey="yaTienesCuenta" />
                          </Link>
                        </Col>
                      </Row>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

VerifyAccount.contextType = AppContext;

export default withApollo(VerifyAccount);
